var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEventUpcoming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33802_5517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9688 28.4688V26.1875H24.4688V12.375H5.53125V19.3438H3.25V6.625C3.25 6.02083 3.47917 5.48958 3.9375 5.03125C4.39583 4.57292 4.92708 4.34375 5.53125 4.34375H7.0625V2.53125H9.5V4.34375H20.5V2.53125H22.9375V4.34375H24.4688C25.0729 4.34375 25.6042 4.57292 26.0625 5.03125C26.5208 5.48958 26.75 6.02083 26.75 6.625V26.1875C26.75 26.7917 26.5208 27.3229 26.0625 27.7812C25.6042 28.2396 25.0729 28.4688 24.4688 28.4688H17.9688ZM10 30.3438L8.40625 28.75L11.75 25.375H1.375V23.0938H11.75L8.40625 19.75L10 18.1562L16.125 24.25L10 30.3438ZM5.53125 10.0938H24.4688V6.625H5.53125V10.0938ZM5.53125 10.0938V6.625V10.0938Z",
    fill: "current",
    stroke: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33802_5517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventUpcoming);
export default __webpack_public_path__ + "static/media/event_upcoming.dd1c7688e9f707a72330bae12aad7072.svg";
export { ForwardRef as ReactComponent };